/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RequestTypeVo
 */
export interface RequestTypeVo {
    /**
     * 请求类型码
     * @type {number}
     * @memberof RequestTypeVo
     */
    requestTypeCode?: number;
    /**
     * 请求类型名称
     * @type {string}
     * @memberof RequestTypeVo
     */
    requestTypeName?: string;
}

/**
 * Check if a given object implements the RequestTypeVo interface.
 */
export function instanceOfRequestTypeVo(value: object): value is RequestTypeVo {
    return true;
}

export function RequestTypeVoFromJSON(json: any): RequestTypeVo {
    return RequestTypeVoFromJSONTyped(json, false);
}

export function RequestTypeVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestTypeVo {
    if (json == null) {
        return json;
    }
    return {
        
        'requestTypeCode': json['requestTypeCode'] == null ? undefined : json['requestTypeCode'],
        'requestTypeName': json['requestTypeName'] == null ? undefined : json['requestTypeName'],
    };
}

export function RequestTypeVoToJSON(json: any): RequestTypeVo {
    return RequestTypeVoToJSONTyped(json, false);
}

export function RequestTypeVoToJSONTyped(value?: RequestTypeVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'requestTypeCode': value['requestTypeCode'],
        'requestTypeName': value['requestTypeName'],
    };
}

